import React from "react";

export class PageNavBar extends React.Component {
    constructor(props) {
        super(props);
        this.state ={
            show_warning:false
        }

        this.nextPageClicked = this.nextPageClicked.bind(this);
        this.prevPageClicked = this.prevPageClicked.bind(this);
        this.showTeacherInfoClicked = this.showTeacherInfoClicked.bind(this);
        this.showBackgroundInfoClicked = this.showBackgroundInfoClicked.bind(this);

    }

    nextPageClicked()
    {
        window.app.nextPage();
    }

    prevPageClicked()
    {
       window.app.prevPage();
    }

    showTeacherInfoClicked()
    {
        window.app.showLeerkrachtInfoClicked();
    }

    showBackgroundInfoClicked()
    {
        window.app.showBackgroundInfoClicked();
    }

    render() {

        return (
            <div className={"tool__pagenavbar__wrapper"}>

                { (this.props.curr_page > 0 || this.props.curr_fase >=2 )  && !this.props.hide_prev &&
                    (
                        <a href="javascript:void(0);" onClick={this.prevPageClicked}><img src={"/digibord/assets/svgs/terug_btn.svg?v=3"} className="tool__pagenavbar__terug_btn" alt="Terug"/></a>
                    )}

                {this.props.curr_fase > 0 &&
                    (
                        <img src={"/digibord/assets/svgs/fase" + this.props.curr_fase + ".svg"}
                             className={"tool_pagenavbar__fase"} alt={"Fase "+ this.props.curr_fase}/>
                    )
                }

                { (this.props.curr_page+1 < window.app.pageHandler.getTotPages(this.props.curr_fase) || this.props.curr_fase != 7) && !this.props.hide_next &&
                    (

                        <a href="javascript:void(0);" onClick={this.nextPageClicked}><img src={"/digibord/assets/svgs/verder_btn.svg?v=3"} className="tool__pagenavbar__verder_btn" alt="Verder"/></a>
                    )}

                { window.app.pageHandler.pageHasTeacherInfo(this.props.curr_fase, this.props.curr_page) &&
                    (
                        <a href="javascript:void(0);" onClick={this.showTeacherInfoClicked}><img src={"/digibord/assets/svgs/leerkracht_btn.svg?v=3"} className="tool__pagenavbar__leerkracht_btn" alt="Leerkrachteninfo"/></a>
                    )}

                { window.app.pageHandler.pageHasBackgroundInfo(this.props.curr_fase, this.props.curr_page) &&
                    (
                        <a href="javascript:void(0);" onClick={this.showBackgroundInfoClicked}><img src={"/digibord/assets/svgs/background_btn.svg?v=3"} className="tool__pagenavbar__background_btn" alt="Achtergrondinfo"/></a>
                    )}



            </div>
        );
    }

}
